import React from "react";

import classRoom from "../../../resources/school/classroom.png";
import clapping from "../../../resources/events/clapping.png";
import vr from "../../../resources/events/vr.png";
import tent from "../../../resources/events/tent.png";
import noodles from "../../../resources/events/noodles.png";
import Card from "../../common/Card";
import Checkmark from "../../common/Checkmark";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

const Camp = () => {
  const { t } = useTranslation("camp");

  return (
    <div className="App">
      <div className="tug-of-war bg-cover bg-center items-center space-y-8 p-8">
        <Row>
          <div className="text-white md:text-2xl text-xl px-28">
            {t("camp.hero.title1")}
          </div>
          <div className="text-white md:text-2xl text-xl px-28">
            {t("camp.hero.title2")}
          </div>
        </Row>

        <Row>
          <p className="text-white md:text-xl text-lg md:w-1/4 text-left md:pb-0 pb-8">
            {t("camp.intro.line1")}
            <br /> <br />
            {t("camp.intro.line2")}
          </p>
          <Card className="bg-white bg-opacity-70 md:w-1/3">
            <ul className="space-y-1">
              <li className="flex items-center">
                <p className="ml-4">{t("camp.info.date")}</p>
              </li>
              <li className="flex items-center">
                <p className="ml-4">{t("camp.info.time")}</p>
              </li>
              <li className="flex items-center">
                <p className="ml-4">{t("camp.info.requirement")}</p>
              </li>
              <li className="flex items-center">
                <p className="ml-4 mb-4">{t("camp.info.address")}</p>
              </li>
            </ul>
            <div className="bg-orange-400 rounded-full text-white py-2 px-12">
              {t("camp.cta")}
            </div>
          </Card>
        </Row>
      </div>

      <div className="p-12 text-4xl text-emerald-500 font-bold bg-green-50">
        {t("camp.slogan")}
      </div>

      <div className="bg-green-50 px-12 py-4">
        <ul className="space-y-4 md:w-1/2 mx-auto text-left">
          <li className="flex items-center">
            <Checkmark />
            <p className="ml-4">{t("camp.bullets.b1")}</p>
          </li>
          <li className="flex items-center">
            <Checkmark />
            <p className="ml-4">{t("camp.bullets.b2")}</p>
          </li>
          <li className="flex items-center">
            <Checkmark />
            <p className="ml-4">{t("camp.bullets.b3")}</p>
          </li>
        </ul>
      </div>

      <div className="space-y-16 m-16">
        <Row spaceClass="md:space-x-16">
          <div className="mb-4 space-y-4 md:order-2 md:ml-16">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("camp.sections.culture1.title")}
            </div>
            <div className="text-sm text-left">
              {t("camp.sections.culture1.body")}
            </div>
          </div>
          <img
            src={classRoom}
            alt="img not found"
            className="md:w-1/2 rounded-xl"
          />
        </Row>

        <Row spaceClass="md:space-x-16">
          <div className="mb-4 space-y-4 md:ml-16">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("camp.sections.culture2.title")}
            </div>
            <div className="text-sm text-left">
              {t("camp.sections.culture2.body")}
            </div>
          </div>
          <img
            src={clapping}
            alt="img not found"
            className="md:w-1/2 rounded-xl"
          />
        </Row>

        <Row spaceClass="md:space-x-16">
          <div className="mb-4 space-y-4 md:order-2 md:ml-16">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("camp.sections.tech.title")}
            </div>
            <div className="text-sm text-left">
              {t("camp.sections.tech.body")}
            </div>
          </div>
          <img src={vr} alt="img not found" className="md:w-1/2 rounded-xl" />
        </Row>

        <Row spaceClass="md:space-x-16">
          <div className="mb-4 space-y-4 md:ml-16">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("camp.sections.activities.title")}
            </div>
            <div className="text-sm text-left">
              {t("camp.sections.activities.body")}
            </div>
          </div>
          <img
            src={tent}
            alt="img not found"
            className="md:w-1/2 rounded-xl"
          />
        </Row>

        <Row spaceClass="md:space-x-16">
          <div className="mb-4 space-y-4 md:order-2 md:ml-16">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("camp.sections.food.title")}
            </div>
            <div className="text-sm text-left">
              {t("camp.sections.food.line1")}
              <br />
              <br />
              {t("camp.sections.food.line2")}
              <br />
              <br />
              {t("camp.sections.food.line3")}
              <br />
              <br />
              {t("camp.sections.food.line4")}
            </div>
          </div>
          <img
            src={noodles}
            alt="img not found"
            className="md:w-1/2 rounded-xl"
          />
        </Row>
      </div>
    </div>
  );
};

export default Camp;
